import axios from 'axios'

var qs = require("qs")
var root = window.API_ROOT
var h5path = '';

//multipart/form-data
//application/x-www-form-urlencoded

//登录
export const login = (params) => {
  return axios.post(root + '/cloud/getToken', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})

}

export const isLaoxian= () => {//老仙独立部署的系统
  return root.indexOf('lxpjapi.eyes.wang')>-1;
}

export const isUGO= () => {//优购独立部署的系统
  return root.indexOf('b2capi.yougoujingcang.com')>-1||root.indexOf('localhost')>-1;
}

export const isDatao= () => {//优购独立部署的系统
  return root.indexOf('b2capi.dataoyanjing.com')>-1||root.indexOf('localhost')>-1;
}

export const isXiaoTuan= () => {//小团独立部署的系统
  return root.indexOf('api.xiaotuanglasses.com')>-1;
}

export const timingDevice = () => {
  return axios.post(root + '/home/timingDevice', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})

}

export const getredis = (params) => {
  return axios.post(root + '/home/getredis', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const removeredis = (params) => {
  return axios.post(root + '/home/removeredis', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const webPath = () => {
  if (h5path == null || h5path == '')
    h5path = window.location.host;
  return h5path;
}

//客服填写订单时需要模拟登录
export const simulationLogin = (params) => {
  return axios.post(root + '/cloud/initialToken', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})

}
//根据token获取用户信息
export const getUserByToken = (params) => {
  return axios.post(root + '/cloud/getUserByToken', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//切换企业
export const setTenant = (params) => {
  var tenantPath = root;
  //  API_ROOT: '"//localhost:8084"',
  if (params.isAppChanged && params.apiurl) {
    //切换了不同的应用，需要请求对应应用的url  比如 http://localhost:8087
    tenantPath = params.apiurl;
  }
  params.LoginFrom = "pcback";
  return axios.post(tenantPath + '/cloud/setTenant', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}
//获取菜单
export const getMenu = (params) => {
  return axios.post(root + '/cloud/getMenu', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//退出登录
export const logout = (params) => {
  return axios.post(root + '/cloud/logout', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//修改密码
export const updatePasswordApi = (params) => {
  return axios.post(root + '/cloud/updatePasswordApi', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//发送验证码
export const sendVerificationCode = (params) => {
  return axios.post(root + '/cloud/sendVerificationCode', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//修改手机号
export const updatePhone = (params) => {
  return axios.post(root + '/cloud/updatePhone', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//注册个人
export const registerPerson = (params) => {
  return axios.post(root + '/cloud/registerPerson', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//token信息
export const gettokenModel = () => {
  return axios.post(root + '/cloud/tokenModel', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//token信息
export const getuserInfoModel = () => {
  return axios.post(root + '/cloud/userInfoModel', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const biframelogin = (params) => {
  return axios.post(root + '/cloud/biframelogin', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getmenuRightModel = () => {
  return axios.post(root + '/cloud/menuRightModel', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const getTenantSet = (params) => {
  return axios.post(root + '/set/tenant/getTenantSet', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const clearParamsRedis = () => {
  return axios.post(root + '/set/tenant/clearParamsRedis', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const saveModuleRight = (params) => {
  return axios.post(root + '/set/tenant/saveModuleRight', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getModuleRight = () => {
  return axios.post(root + '/set/tenant/getModuleRight', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const checksaveModuleRight = () => {
  return axios.post(root + '/set/tenant/checksaveModuleRight', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const checkModuleRight = (params) => {
  return axios.post(root + '/set/tenant/checkModuleRight', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const tenantidlist = (params) => {
  return axios.post(root + '/set/tenant/tenantidlist', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const employright = (params) => {
  return axios.post(root + '/set/tenant/employright', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const testAPI = (url, params) => {
  return axios.post(root + url, qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const testJSONAPI = (url, params) => {
  return axios.post(root + url, qs.stringify(params), {headers: {"Content-Type": "application/json","clientid":"00021036ed24-71f5-4049-abe8-650410eda145","secret":"XQCYPWvoGz5b8kmSHHpjwdxqjDiKPY+2F3eC4J6VACOjrqrSv1fj+DzWNffDvET8INViS"}})
}

export const testgetAPI = (url, params) => {
  return axios.get(root + url, {params:params})
}



// WEBPACK FOOTER //
// ./src/api/login.js